module.exports = __webpack_public_path__ + "media/images/online-druckerei-printworld-9233f962ca12f7e82b13c314223e0924.png";